.fp-responsive-grid.-cols3.-cols1-up-md
  .fp-responsive-grid--column
    FeatureCardVue(illustration='medal' name='Medal' translate-key='earnTokens')
  .fp-responsive-grid--column
    FeatureCardVue(illustration='star' name='Star' translate-key='experienceExclusives')
  .fp-responsive-grid--column
    FeatureCardVue(illustration='crown' name='Crown' translate-key='collectExclusives')
